import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOverviewFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "-1 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#2B2B2B",
		d: "M5.584 16V9.776h2.592V16h5.6V3.536L6.88 0 0 3.536V16z"
	})
});
export default SvgOverviewFilled;
